/*
Tracks the maximum scroll position per page.
*/
import Tracking from "../uidispatcherapi/Tracking";
const ScrollTracking = {
	rootElement: null,
	checkPositionsInterval: 200,
	trackingInterval: 500,
	intervalId: 0,
	currentPage: document.location.href,
	maxTop: 0,
	lastChange: 0,
	tracked: false,
	startScrollTracking: function () {
		this.intervalId = window.setInterval(() => this.trackScrollPosition(), this.checkPositionsInterval);
		const oldOnUnload = window.onunload;

		window.onunload = function () {
			this.stopScrollTracking();
			this.trackScrollPosition();

			if (oldOnUnload !== null && typeof oldOnUnload === "function") {
				//@ts-expect-error: oldOnUnload expected one argument but not provided
				oldOnUnload();
			}
		}.bind(this);
	},
	stopScrollTracking: function () {
		window.clearInterval(this.intervalId);
	},
	trackScrollPosition: function () {
		try {
			const currentTop = window.pageYOffset;
			const currentHeight = document.body ? document.body.scrollHeight : 0;
			const currentPage = document.location.href;

			// The page has changed, track current value & reset the scrolling
			if (this.currentPage !== currentPage) {
				if (!this.tracked) {
					this.track(currentPage, currentTop, currentHeight);
				}

				this.maxTop = -1;
				this.currentPage = currentPage;
			}

			const now = Date.now();

			if (this.maxTop !== currentTop) {
				this.maxTop = currentTop;
				this.lastChange = now;
				this.tracked = false;
			}

			if (!this.tracked && now - this.lastChange > this.trackingInterval) {
				this.track(currentPage, currentTop, currentHeight);
				this.tracked = true;
			}
		} catch (err) {
			console.error(err);
		}
	},
	track: function (currentPage: string, currentTopPosition: number, currentPageHeight: number) {
		const tags = {
			currentPage: currentPage,
			positionHeight: currentTopPosition,
			pageHeight: currentPageHeight,
			browserHeight: window.innerHeight,
		};
		Tracking.trackStructuredEvent("platform", "ui", "app.scroll", {
			tags,
		});
	},
};
export default ScrollTracking;
